import React, { ReactNode } from 'react';
import { Frame, Navigation } from '@shopify/polaris';
import { useLocation, useNavigate } from 'react-router-dom';

interface AppLayoutProps {
  children: ReactNode;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const navigationMarkup = (
    <Navigation location={location.pathname}>
      <Navigation.Section
        items={[
          {
            url: '/',
            label: 'Brand Management',
            selected: location.pathname === '/' || location.pathname === '/brands',
            onClick: () => navigate('/brands'),
          },
          {
            url: '/settings',
            label: 'Settings',
            selected: location.pathname === '/settings',
            onClick: () => navigate('/settings'),
          },
        ]}
      />
    </Navigation>
  );

  return (
    <Frame navigation={navigationMarkup}>
      {children}
    </Frame>
  );
};

export default AppLayout;
